var _g, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStkTransferOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1386_216)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C6.68629 0 4 2.68629 4 6V34C4 37.3137 6.68629 40 10 40H38C41.3137 40 44 37.3137 44 34V22.8448C43.9118 22.853 43.8225 22.8571 43.7321 22.8571C42.1542 22.8571 40.875 21.578 40.875 20C40.875 18.422 42.1542 17.1429 43.7321 17.1429C43.8225 17.1429 43.9118 17.147 44 17.1552V6C44 2.68629 41.3137 0 38 0H10Z",
    fill: "#04B7B1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7858 28.5705C34.3908 28.5705 33.2126 29.4689 32.7689 30.7134H28.2858V26.8945L31.9217 25.2694C32.3162 25.1009 32.5715 24.7133 32.5715 24.2848V15.7134C32.5715 15.7105 32.5702 15.708 32.5702 15.7051L24.5358 19.276V28.5705L26.1429 27.8522V31.7848C26.1429 32.3765 26.6221 32.8562 27.2143 32.8562H32.769C33.2127 34.1007 34.3908 34.9991 35.7858 34.9991C37.5582 34.9991 39.0001 33.5573 39.0001 31.7848C39.0001 30.0124 37.5582 28.5705 35.7858 28.5705Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2857 13.1783V9.28571H32.7689C33.2126 10.5302 34.3908 11.4286 35.7857 11.4286C37.5582 11.4286 39 9.98675 39 8.21429C39 6.44182 37.5582 5 35.7857 5C34.3908 5 33.2126 5.89839 32.7689 7.14286H27.2143C26.6221 7.14286 26.1429 7.62259 26.1429 8.21429V12.256C25.145 11.8266 24.4217 11.5154 24.4217 11.5154C24.1538 11.3993 23.8462 11.3993 23.5783 11.5154C23.5783 11.5154 22.855 11.8266 21.8571 12.256V8.21429C21.8571 7.62259 21.3779 7.14286 20.7857 7.14286H15.2311C14.7874 5.89839 13.6092 5 12.2143 5C10.4418 5 9 6.44182 9 8.21429C9 9.98675 10.4418 11.4286 12.2143 11.4286C13.6092 11.4286 14.7874 10.5302 15.2311 9.28571H19.7143V13.1783C17.8492 13.9813 16.0065 14.7748 15.9918 14.7829L24 18.3421L32.0082 14.7829C31.9935 14.7748 30.1508 13.9813 28.2857 13.1783Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4286 15.7134V24.2848C15.4286 24.7133 15.6839 25.1009 16.0783 25.2694L19.7143 26.8945V30.7134H15.2311C14.7874 29.4689 13.6092 28.5705 12.2143 28.5705C10.4418 28.5705 9 30.0124 9 31.7848C9 33.5573 10.4418 34.9991 12.2143 34.9991C13.6092 34.9991 14.7874 34.1007 15.2311 32.8562H20.7857C21.3779 32.8562 21.8571 32.3765 21.8571 31.7848V27.8522L23.4643 28.5705V19.276L15.4298 15.7051C15.4298 15.708 15.4286 15.7105 15.4286 15.7134Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1386_216",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1386_216"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1386_216",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStkTransferOn);
export default __webpack_public_path__ + "static/media/StkTransferOn.f4c9209e4e958e6243ad7a9585a0d6cc.svg";
export { ForwardRef as ReactComponent };